var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.511C21.1341 8.79546 21.75 9.63917 21.75 10.6082V14.8938C21.75 16.0304 20.9026 16.9942 19.7697 17.0867C19.4308 17.1143 19.0909 17.1385 18.75 17.1592V20.25L15.75 17.25C14.3963 17.25 13.0556 17.1948 11.7302 17.0866C11.4319 17.0622 11.1534 16.9775 10.9049 16.845M20.25 8.511C20.0986 8.46229 19.9393 8.42997 19.7739 8.41625C18.4472 8.30613 17.1051 8.24997 15.75 8.24997C14.3948 8.24997 13.0528 8.30613 11.7261 8.41624C10.595 8.51012 9.75 9.4732 9.75 10.6082V14.8937C9.75 15.731 10.2099 16.4745 10.9049 16.845M20.25 8.511V6.63728C20.25 5.01586 19.0983 3.61062 17.4903 3.40188C15.4478 3.13673 13.365 2.99997 11.2503 2.99997C9.13533 2.99997 7.05233 3.13675 5.00963 3.40196C3.40173 3.61071 2.25 5.01595 2.25 6.63735V12.8626C2.25 14.484 3.40173 15.8893 5.00964 16.098C5.58661 16.1729 6.16679 16.2376 6.75 16.2918V21L10.9049 16.845",
    stroke: "#cbd5e1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSurvey);
export default __webpack_public_path__ + "static/media/ai-survey.c9e1a716292cadc8e1ef3d14a56dfeb8.svg";
export { ForwardRef as ReactComponent };